const Template = `<div>
<div  class="left-menu">
	<b-form-input class='input-dark' v-model="filter" :placeholder="$t('general.search')"></b-form-input>
  
<div  class="left-menu-table">

    <b-table
      id="left-table"
      :filter="filter"
      :items="modems"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="fields"
      striped
      borderless
      small
      hover
      dark
  		@row-clicked="modemListClick"
    >

          <template v-slot:cell(serial)="data"
          >
          {{ shortSerial(data.item)  }}

        </template>
     	<template v-slot:cell(wire)="data">
       		{{ wire(data.item) }}
      	</template>
 	  	
    </b-table>
  </div>

      <b-pagination
      v-model="currentPage"
      :total-rows="menuRows"
      :per-page="perPage"
      aria-controls="left-table"
            first-text="⏮"
      prev-text="⏪"
      next-text="⏩"
      last-text="⏭"
    ></b-pagination>
  </div>    
</div>`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/left_menu/template.js